import React, { useEffect, useState } from 'react';
import { query, collection, orderBy } from 'firebase/firestore';
import { PictureGallery } from '../../../components';
import { useParams } from 'react-router-dom';
import { db } from '../../../../firebase/clientApp';
import { USERS, PROPERTIES, IMAGES } from '../../../../firebase';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { useUser } from '../../../hooks/useUser';

//not used needs to be removed or refactored
export default function GalleryInput({
  name = '',
  label = '',
  description = '',
}) {
  const { propertyId } = useParams();
  const { user } = useUser();

  const [propertyImages, setPropertyImages] = useState([]);

  const imagesRef = query(
    collection(
      db,
      `${USERS}/${user.uid}/${PROPERTIES}/${propertyId}/${IMAGES}`
    ),
    orderBy('createdAt')
  );

  const [images, loading, error] = useCollectionData(imagesRef, {
    snapshotListenOptions: { includeMetadataChanges: true },
  });

  useEffect(() => {
    if (images) {
      const imageData = [];
      images.forEach((image) => {
        imageData.push({
          id: image.id,
          url: image.fileUrlBE,
        });
      });
      setPropertyImages(imageData);
    }
  }, [images]);

  return (
    <>
      <div className="">
        <div className="col-start-1 row-start-1 px-4 invalidClass sm:px-6 border-b"></div>
        <PictureGallery
          propertyId={propertyId}
          currentUserId={user.uid}
          loading={loading}
          error={error}
          propertyImages={propertyImages}
        />
      </div>
    </>
  );
}
